import { Anchor, Box, Checkbox, Label, LabeledControl, Text } from '@zillow/constellation-10';

import { EXTERNAL_URLS } from '../../constants/urls';

type Props = {
  isRoomForRentChecked: boolean;
  isRoomForRentDisabled: boolean;
  toggleRoomForRentChecked?: (() => void) | null;
};

const RoomForRentCheckbox = ({
  isRoomForRentChecked,
  isRoomForRentDisabled,
  toggleRoomForRentChecked = null,
}: Props) => (
  <Box css={{ paddingBlock: '200' }} data-testid="RoomForRentCheckbox">
    <Box css={{ display: 'flex' }}>
      <LabeledControl
        controlId="LabeledControl-roomForRent"
        label={<Label>This is a room for rent with a shared living space</Label>}
        control={<Checkbox checked={isRoomForRentChecked} onChange={() => toggleRoomForRentChecked?.()} />}
        disabled={isRoomForRentDisabled}
      />
    </Box>

    {isRoomForRentChecked && (
      <Text data-testid="RR-Notice" textStyle="body-sm">
        Your room for rent listing will be posted on Zillow, HotPads, and Trulia.&nbsp;
        <Anchor href={EXTERNAL_URLS.ROOM_FOR_RENT_LEARN_MORE} rel="noopener noreferrer" target="_blank">
          Learn more
        </Anchor>
      </Text>
    )}
  </Box>
);

export default RoomForRentCheckbox;
